module.exports = __webpack_public_path__ + "img/6.45880b64.png";